import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function AddProcesos({ handleNewProcesos, editingProceso }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const [codigo, setCodigo] = useState('');
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState(1);
    const [empresa, setEmpresa] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const [IngresadoPor, setIngresadoPor] = useState('');

    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        const fechaISO = fecha.toISOString().slice(0, -1); // Elimina la 'Z'
        return fechaISO;
    }

    const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        if (editingProceso) {
            setCodigo(editingProceso.codigo);
            setDescripcion(editingProceso.descripcion);
            setEmpresa(editingProceso.idEmpresa)
            setIngresadoPor(editingProceso.ingresadoPor);

            setModificacion(2);
        } else {
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editingProceso]);

    const fetchEmpresas = async () => {
        try {
            const response = await fetch(`${server}/MgEmpresas`);
            const data = await response.json();

            setEmpresas(data.$values);
        } catch (error) {
            console.error('Error al cargar las empresas:', error);
        }
    };
    useEffect(() => {
        fetchEmpresas();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();

        const proceso = {
            id: editingProceso ? editingProceso.id : 0,
            codigo,
            descripcion,
            idEmpresa:empresa,
            IngresadoPor: !editingProceso ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editingProceso ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
        
        };
        Object.keys(proceso).forEach(key => proceso[key] === undefined && delete proceso[key]);

        const method = editingProceso ? 'PUT' : 'POST';
        const endpoint = editingProceso ? `${server}/MgProcesoes/${editingProceso.id}` : `${server}/MgProcesoes`;

        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(proceso)
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });  
                              setCodigo('');
                setDescripcion('');
                setEmpresa('')
                handleNewProcesos();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
      
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el proceso',
                text: error || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>{editingProceso ? "Editar Proceso" : "Agregar Proceso"}</h2>
            <br />
            <form id="Perfiles" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="codigo">
                        Código: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="codigo"
                            required="required"
                            className="form-control"
                            value={codigo}
                            onChange={(e) => setCodigo(e.target.value)}
                        />
                    </div>
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcion">
                        Descripción: <span className="required">*</span>
                    </label>
                    <div className="col-md-3 col-sm-3">
                        <input
                            type="text"
                            id="descripcion"
                            required="required"
                            className="form-control"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                </div>
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="Empresa">Empresa</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={empresa} onChange={(e) => setEmpresa(e.target.value)}>
                            <option value="">Elija una opcion</option>
                            {empresas.map((empresa) => (
                                <option key={empresa.idEmpresa} value={empresa.idEmpresa}>{empresa.nombreCompleto}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Proceso')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddProcesos;
